import api from "services/api";

/**
 * Fetch receipt data for an approved, paid enrollment.
 * @param {string} enrollId
 * @returns {Promise<object>}
 */
export const fetchReceiptByEnrollId = async (enrollId) => {
  const response = await api.get(`/receipts/${enrollId}`);
  return response?.data?.data;
};

/**
 * Whether receipt download should be shown for a plan row.
 * @param {{ status?: string }} plan
 * @returns {boolean}
 */
export const canDownloadReceipt = (plan) => {
  return String(plan?.status || "").toLowerCase() === "approved";
};
